/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ApplicantWorkerLinkService {

    /**
     * Record which WX worker carries an applicant, in clusterTime order
     * Writes applicants.wx_external_id on accounts with submission-time worker creation. Each write is a snapshot of which worker carries the applicant. A snapshot at or below the clusterTime of the last one applied answers 409 and changes nothing; WX does not retry it.
     * @param applicantExternalId Applicant external ID
     * @param authorization Bearer <WX service JWT carrying hireapi:applicant-worker-link>
     * @param requestBody
     * @returns any applied
     * @throws ApiError
     */
    public static putInternalApiWxApplicantsWorkerLink(
        applicantExternalId: string,
        authorization: string,
        requestBody?: {
            /**
             * Worker carrying the applicant when WX read it; null when none does
             */
            wx_external_id: string | null;
            /**
             * operationTime of the WX read that found the worker, from the primary or a majority read
             */
            cluster_time: {
                't': number;
                'i': number;
            };
        },
    ): CancelablePromise<{
        outcome: string;
    }> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/internal_api/wx/applicants/{applicant_external_id}/worker_link',
            path: {
                'applicant_external_id': applicantExternalId,
            },
            headers: {
                'Authorization': authorization,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                404: `no such applicant; WX does not retry`,
                409: `stale snapshot`,
                410: `the applicant was erased; WX deletes the worker it holds for it and does not retry`,
                422: `not enabled or malformed`,
            },
        });
    }

}